import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { BillingIntervalUnitModule_fromString, BillingIntervalModule_fromInt, BillingIntervalUnit$reflection, BillingInterval$reflection } from "../../DomainTypes.js";
import { string_type, int32_type, record_type, option_type, class_type, bool_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { bool, string, int, object, option as option_1, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { bind } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { DateModule_parse, DateFormat_get_yyyy$002DMM$002Ddd } from "../../Svea.Dry/Time.js";

export class BillingInfo extends Record {
    constructor(BillingInterval, BillingIntervalUnit, NoNextInvoice, BilledTo) {
        super();
        this.BillingInterval = BillingInterval;
        this.BillingIntervalUnit = BillingIntervalUnit;
        this.NoNextInvoice = NoNextInvoice;
        this.BilledTo = BilledTo;
    }
}

export function BillingInfo$reflection() {
    return record_type("Containers.BillingInfoTable.Model.BillingInfo", [], BillingInfo, () => [["BillingInterval", BillingInterval$reflection()], ["BillingIntervalUnit", BillingIntervalUnit$reflection()], ["NoNextInvoice", bool_type], ["BilledTo", option_type(class_type("System.DateOnly"))]]);
}

export function BillingInfo_get_Decoder() {
    return (value_4) => fromString((path_4, value_3) => option_1((path_3, v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, option, objectArg_3, format;
        return new BillingInfo(BillingIntervalModule_fromInt((objectArg = get$.Required, objectArg.Field("BillingInterval", uncurry(2, int)))), BillingIntervalUnitModule_fromString((objectArg_1 = get$.Required, objectArg_1.Field("BillingIntervalUnit", string))), (objectArg_2 = get$.Required, objectArg_2.Field("NoNextInvoice", bool)), (option = ((objectArg_3 = get$.Optional, objectArg_3.Field("BilledTo", string))), bind((format = DateFormat_get_yyyy$002DMM$002Ddd(), (s) => DateModule_parse(format, s)), option)));
    }, path_3, v), path_4, value_3), value_4);
}

export class UpdateBillingInfoDTO extends Record {
    constructor(BillingInterval, BillingIntervalUnit, NoNextInvoice, BilledTo) {
        super();
        this.BillingInterval = (BillingInterval | 0);
        this.BillingIntervalUnit = BillingIntervalUnit;
        this.NoNextInvoice = NoNextInvoice;
        this.BilledTo = BilledTo;
    }
}

export function UpdateBillingInfoDTO$reflection() {
    return record_type("Containers.BillingInfoTable.Model.UpdateBillingInfoDTO", [], UpdateBillingInfoDTO, () => [["BillingInterval", int32_type], ["BillingIntervalUnit", string_type], ["NoNextInvoice", bool_type], ["BilledTo", option_type(string_type)]]);
}

